import { apiFetch } from "../useApi";

export default async function updateCampaignsStatus({ campaignIds, status }) {
  const response = await apiFetch(`/campaigns/update_campaigns_status`, {
    method: 'PUT',
    body: JSON.stringify({ campaignIds, status }),
  });
}
